import { Link } from 'react-router-dom';
import { Button } from '@upmc/ims.component-library';

import { Headline6 } from '../../../components/UI/MDC/Typography/Typography';
import * as utils from '../../../utils';
import classes from '../UserAccessReview.module.scss';

const ErrorPage = props => {
	return (
		<section
			className={utils.concatenateClassNames(
				['edit__button--group', 'center'],
				classes
			)}
		>
			<Headline6>
				{props.message
					? props.message
					: 'Error Occurred: We apologize for the inconvenience.  Please try again.'}
			</Headline6>
			<Link
				to={{
					pathname: '/UserAccessReview/Dashboard',
				}}
			>
				<Button
					variant='outlined'
				>
					Back to Dashboard
				</Button>
			</Link>
		</section>
	);
};

export default ErrorPage;
